import Primary from './primary';
import Secondary from './secondary';
import Tertiary from './tertiary';
import PrimaryLink from './primaryLink';
import Icon from './icon';
import IconSecondary from './iconSecondary';
import { Size } from './button';
import Quaternary from './quaternary';
var StyledButton = {
    Size: Size,
    Primary: Primary,
    Secondary: Secondary,
    Tertiary: Tertiary,
    Quaternary: Quaternary,
    PrimaryLink: PrimaryLink,
    Icon: Icon,
    IconSecondary: IconSecondary,
};
export default StyledButton;
//# sourceMappingURL=index.js.map